import { useMemo } from 'react'
import qs from 'query-string'
import isUndefined from 'lodash/isUndefined'
import { omitBy } from 'lodash'

import { ROUTE_PATH } from 'lib/paths'
import { useNavigate, getI18nPath } from 'features/i18n/router'

import { MODAL_MODE } from 'components/Modal/config'

const usePageModal = () => {
  const navigate = useNavigate()

  const open = (modal: MODAL_MODE, params: Object = {}) => {
    navigate(generatePageModalUrl(modal, params))
  }

  const generatePageModalUrl = (
    modal: MODAL_MODE,
    params: Object = {},
    toPath?: string
  ) => {
    const search = qs.stringify(
      omitBy({ modalMode: modal, ...params }, isUndefined)
    )

    return `${
      toPath ??
      (modal === MODAL_MODE.LOGIN
        ? getI18nPath(ROUTE_PATH.HOME)
        : window.location.pathname)
    }?${search}`
  }

  const pageModalData = useMemo(() => {
    const searchParams = qs.parse(window.location.search) as {
      modalMode: MODAL_MODE
      returnPath?: string
    }
    if (searchParams.returnPath) {
      searchParams.returnPath = decodeURIComponent(searchParams.returnPath)
    }

    return searchParams
  }, [window.location.search])

  return {
    open,
    pageModalData,
    generatePageModalUrl,
    pathname: window.location.pathname,
  }
}

export default usePageModal
